import { SectionHeader } from '../componentsV2/SectionHeader'
import { StockListItem } from './StockListItem'
import styled from 'styled-components'
import { ResidentMedication } from '../types'

type StockSectionProps = {
  title: string
  medications: ResidentMedication[]
  residentId: string
}

export const StockSection = ({
  title,
  medications,
  residentId,

}: StockSectionProps) => {
  if (!medications || medications.length === 0) return null

  return (
    <>
      <StyledSectionHeader title={title} />
      <ListItemsContainer>
        {medications.map((medication) => (
          <StockListItem
            key={medication.residentMedicationId}
            medication={medication}
            residentId={residentId}
          />
        ))}
      </ListItemsContainer>
    </>
  )
}

const StyledSectionHeader = styled(SectionHeader)`
  margin: 24px 0 16px 24px;
`

const ListItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
